<template>
  <div class="image-container" v-bind:class="{ zoomed: zoomed }">
    <img
      crossorigin="anonymous"
      :src="item.links.content_url"
      :id="zoomed ? 'zoomed-image-item' : 'image-item'"
      v-on:click="toggleZoom"
      :class="zoomed ? 'zoomed mx-auto d-block' : ''"
      :alt="item.attributes.name_without_extension"
    />
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      zoomed: false,
    };
  },
  methods: {
    toggleZoom: function () {
      this.zoomed = !this.zoomed;
      this.$emit(this.zoomed ? "zoom" : "unzoom");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../packs/application.scss";

.image-container.zoomed {
  width: 100%;
  height: auto;
  overflow: auto;
}

#image-item {
  // 300 is for header and comments section below.
  max-height: calc(100vh - 300px);
}

img {
  cursor: zoom-in;
}

img.zoomed {
  cursor: zoom-out;
  max-width: 250%;
  min-width: 80vw;
  height: auto;
}
</style>
